module.exports = __webpack_public_path__ + "img/feedback-right-arrow.41d82c68.svg";